import React from "react";
import { Link } from "react-router-dom";

import {
    FiTrendingUp
} from "react-icons/fi";


const list_trend =[
    {
        rank: 1,
        title: 'MRS',
        url: '/presale/mrs'
    },
    {
        rank: 2,
        title: 'SHO',
        url: '/presale/mrs'
    },
    {
        rank: 3,
        title: 'BTC',
        url: '/presale/mrs'
    },
    {
        rank: 4,
        title: 'BNB',
        url: '/presale/mrs'
    },
    {
        rank: 5,
        title: 'LTO',
        url: '/presale/mrs'
    },
    {
        rank: 6,
        title: 'OMD',
        url: '/presale/mrs'
    },
    {
        rank: 7,
        title: 'ONE',
        url: '/presale/mrs'
    },
    {
        rank: 8,
        title: 'THR',
        url: '/presale/mrs'
    },
    {
        rank: 9,
        title: 'MIO',
        url: '/presale/mrs'
    },
    {
        rank: 10,
        title: 'VET',
        url: '/presale/mrs'
    },
]

const Trending = () => {
    return (
        <div className="trending-wrap">
            <div className="trending-title">
                <FiTrendingUp />
                <span>Trending</span>
            </div>
            <ul className="trending-item-wrap">
                {
                    list_trend.map((item,index) => 
                        <li className="trending-item" key={index}>
                            <span>#{item.rank}</span>
                            <Link to={item.url}>{item.title}</Link>
                        </li>
                    )
                }
            </ul>
        </div>
    )
}

export default Trending;
